import { getMasterProductId } from '../../common/helpers/productIdHelpers';

export const productBaseMixin = {
  computed: {
    /**
     * Get the product name
     * @returns {string} Product name
     */
    name() {
      return this.product.productName;
    },

    productId() {
      return this.product?.id;
    },

    productImages() {
      return this.product?.bylImages;
    },

    /**
     * Unique pid to update a product with product variations
     */
    upid() {
      return getMasterProductId(this.productId);
    },
  },
};

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  ...productBaseMixin,
};
